import JalanExperience from './JalanExperience/JalanExperience';

// reservationページのじゃらん体験
if (document.querySelector('[data-role="jalan-form"]') !== null) {
  // eslint-disable-next-line no-new
  new JalanExperience({
    requestBaseURI: '/jalan_experiences',
    prefId: '010000', // kenCd
    areaId: '011400', // lrgCd
    cityId: '012020000', // cityCd
    itemSizePerPage: 24,
    initPageNum: 1,
    sortType: 1,
    view: {
      noImagePath: document.querySelector('[data-role="jalan-no-img-path"]').src,
      sortButtonActiveClassName: '--active',
      hideClassName: 'd-none',
    },
  });
}
